import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { canWrite } from 'features/Users/utils'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { useLogin } from 'features/Login/hooks'
import { RulesActions } from 'features/Loyalty/components/RulesActions'
import { IRulesListProps } from './types'

const RulesList = ({ rules, campaignId }: IRulesListProps): ReactElement => {
  const login = useLogin()
  const hasActions = canWrite(FEATURES.LOYALTY_REWARD, login.accessToken.policies)

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {hasActions && <Th />}
            <Th>
              <FormattedMessage id="loyalty.campaign.rules.list.column.name" defaultMessage="Rule Name" />
            </Th>
            <Th>
              <FormattedMessage id="loyalty.campaign.rules.list.column.description" defaultMessage="Description" />
            </Th>
            <Th>
              <FormattedMessage
                id="loyalty.campaign.rules.list.column.rewardObtained"
                defaultMessage="Reward Obtained"
              />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {rules.map((rule) => {
            return (
              <Tr key={rule.id}>
                {hasActions && (
                  <Td>
                    <RulesActions rule={rule} campaignId={campaignId} />
                  </Td>
                )}
                <Td>{rule.name}</Td>
                <Td>{rule.description}</Td>
                <Td>{rule.effects[0]?.reward.name}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}

export default RulesList
